import { gql } from "@apollo/client";

import { TICKET_TEMPLATE_NODE_FRAGMENT } from "./fragments";

export const TICKET_TEMPLATES_QUERY = gql`
  ${TICKET_TEMPLATE_NODE_FRAGMENT}
  query TicketTemplates(
    $skip: Int
    $take: Int
    $filters: TicketTemplateFilterInput
    $orderBy: [TicketTemplateOrderByInput!]
    $ticketPoolsSkip: Int
    $ticketPoolsTake: Int
    $ticketPoolsFilters: TicketPoolFilterInput
    $ticketPoolsOrderBy: [TicketPoolOrderByInput!]
    $skipTicketPools: Boolean = false
  ) {
    ticketTemplates(
      skip: $skip
      take: $take
      filters: $filters
      orderBy: $orderBy
    ) {
      nodes {
        ...TicketTemplateNode
      }
      count
    }
  }
`;

export const TICKET_TEMPLATE_QUERY = gql`
  ${TICKET_TEMPLATE_NODE_FRAGMENT}
  query TicketTemplateQuery(
    $id: Int!
    $ticketPoolsSkip: Int
    $ticketPoolsTake: Int
    $ticketPoolsFilters: TicketPoolFilterInput
    $ticketPoolsOrderBy: [TicketPoolOrderByInput!]
    $skipTicketPools: Boolean = false
  ) {
    ticketTemplate(id: $id) {
      ...TicketTemplateNode
    }
  }
`;
